import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const ChildPassportInfoStep: React.FC = () => {
  const { goNext, goBack } = useWizard();
  const [title, setTitle] = useState<string>('Pas til barn');
  const [body, setBody] = useState<string[]>([
    'Når du ansøger om pas til et barn under 18 år, skal begge forældre med forældremyndighed give samtykke.'
  ]);
  const [bullets, setBullets] = useState<string[] | undefined>([
    'Barnet skal møde personligt op',
    'Begge forældre med forældremyndighed skal give samtykke'
  ]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.child_info).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setBody(c.body);}
      if (c?.bullets && c.bullets.length > 0) {setBullets(c.bullets);}
    });
  }, []);

  return (
    <StepContainer title={title}>
      <InfoBox type="warning">
        {body.map((p, i) => <p key={i}>{p}</p>)}
        {bullets && bullets.length > 0 && (
          <ul>
            {bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        )}
      </InfoBox>
      <NavigationButtons onBack={goBack} onNext={goNext} />
    </StepContainer>
  );
};

export default ChildPassportInfoStep;
